import React from 'react';

const onboardingSuppressKey = onboardingID =>
  `__onboarding-${onboardingID}-suppress__`;

const useSuppressFlagStorage = onboardingID => {
  const checkSuppress = React.useCallback(
    () => {
      const value = window.localStorage.getItem(
        onboardingSuppressKey(onboardingID),
      );
      return value && JSON.parse(value) === true;
    },
    [onboardingID],
  );

  const setSuppress = React.useCallback(
    value => {
      window.localStorage.setItem(onboardingSuppressKey(onboardingID), value);
    },
    [onboardingID],
  );

  return {
    checkSuppress,
    setSuppress,
  };
};

export default useSuppressFlagStorage;
